<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Theo tháng</div>
                <div class="child-w-80">
                  <!-- v-model="searchParams.roomNumber" -->
                  <el-select v-model="searchParams.month">
                    <el-option value=""></el-option>
                    <el-option
                      v-for="(month, index) in monthList"
                      :key="index"
                      :value="month.value"
                      :label="month.name"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelIdList"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Từ ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo dự báo</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              :is-row-selectable="isRowSelectable"
              row-selection="single"
              :auto-select-first-row="false"
              class="agGrid"
              :auto-size-cell="true"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Mã đặt phòng: Hiển thị mã đặt phòng</li>
            <li>Số lượng phòng đặt: Hiển thị số phòng đặt</li>
            <li>Tên khách: Hiển thị thông tin khách đặt</li>
            <li>Nguồn: Hiển thị nguồn của đặt phòng</li>
            <li>Hạng phòng: Hiển thị Mã hạng phòng</li>
            <li>Số lượng phòng theo hạng phòng:</li>
            <li>
              Ngày đặt : hiển thị ngày, thời gian đặt phòng theo format:
              DDMMYYYY HHMM
            </li>
            <li>Ngày đến: Ngày đến của đặt phòng</li>
            <li>Ngày đi: Hiển thị ngày đi của đặt phòng</li>
            <li>Số lượng khách: số lượng khách theo hạng phòng</li>
            <li>
              Số đêm: Hiển thị số đêm đặt chia theo khoảng thời gian mã giá.
            </li>
            <li>Giá phòng: Hiển thị giá phòng</li>
            <li>
              Doanh thu thực: Hiển thị doanh thu thự là doanh thu sau khi áp
              dụng các chương trình giảm giá khi đặt phòng. Tính theo: Doanh thu
              thực = số đêm*Giá phòng giảm giá khi đặt phòng
            </li>
            <li>Nhân viên: Nhân viên tạo đặt phòng</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import InfoBtn from '../components/InfoBtn.vue'
import { getListForecast } from '@/api/report_service/forecastReport'
import { getAllHotel } from '@/api/hotel'

export default {
  components: {
    CalendarRange,
    InfoBtn
  },
  data() {
    return {
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      loading: false,
      monthList: [
        {
          value: 1,
          name: 'Tháng 1'
        },
        {
          value: 2,
          name: 'Tháng 2'
        },
        {
          value: 3,
          name: 'Tháng 3'
        },
        {
          value: 4,
          name: 'Tháng 4'
        },
        {
          value: 5,
          name: 'Tháng 5'
        },
        {
          value: 6,
          name: 'Tháng 6'
        },
        {
          value: 7,
          name: 'Tháng 7'
        },
        {
          value: 8,
          name: 'Tháng 8'
        },
        {
          value: 9,
          name: 'Tháng 9'
        },
        {
          value: 10,
          name: 'Tháng 10'
        },
        {
          value: 11,
          name: 'Tháng 11'
        },
        {
          value: 12,
          name: 'Tháng 12'
        }
      ],
      dialogFormVisible: false,
      hotelList: [],
      defaultSearchParams: {
        month: '',
        hotelIdList: [],
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD')
      },
      searchParams: {
        month: '',
        hotelIdList: [],
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD')
      },
      isRowSelectable: node => !node.data.isFullWidthRow,

      columns: [
        // {
        //   headerName: '',
        //   field: 'index',
        //   minWidth: 60,
        //   maxWidth: 60,
        //   headerCheckboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   checkboxSelection: true,
        //   resizable: false
        //   // cellStyle: {'padding-left': '12px'}
        // },
        {
          headerName: 'Khách quan',
          field: 'objective',
          // cellClass: "grid-cell-centered",
          sortable: false
        },
        {
          headerName: 'Trung bình',
          field: 'medium',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        },
        {
          headerName: 'Bi quan',
          field: 'pessimistic',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },
  created() {
    this.getListHotel()
  },
  mounted() {
    this.attachData()
  },
  methods: {
    handleCommand(cmmd) {
      this.$message('click on item ' + cmmd)
    },
    setDateRange(range) {
      // console.log(range.start, range.end)

      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async attachData() {
      this.loading = true
      let data = await getListForecast(this.searchParams)
      // console.log(data)
      this.rows = []

      data?.data.forEach(roomLevel => {
        this.rows = [
          ...this.rows,
          {
            name: roomLevel.roomLevel,
            isFullWidthRow: true
          },
          roomLevel.status
        ]
      })
      this.loading = false
      // this.rows = data.data
    },
    onSearch() {
      this.attachData()
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
    }
  }
}
</script>

<style lang="scss"></style>
